import _ from "lodash";

import { newChecklist } from "../generators/checklist";
import { SoftwareAddonTemplate } from "../model/addonTemplate";
import {
  checklistRoleDefaultTitles,
  checklistRoles,
  isChecklist,
  isChecklistHeader,
  isChecklistItem,
} from "../model/checklistAppState";
import { ChecklistDocument } from "../model/editorState";
import { deserializeChecklistElement } from "../state/convert";

export function insertFromTemplate(
  checklistDocument: ChecklistDocument,
  template: SoftwareAddonTemplate
): void {
  template.content.forEach((templateChecklist) => {
    const targetChecklist = _.find(checklistDocument.contents.checklists, (c) => {
      if (isChecklist(c) && c.role) {
        return templateChecklist.roles.includes(c.role[0]);
      }
      return false;
    });

    const hydratedItems = templateChecklist.content.map(deserializeChecklistElement);

    if (targetChecklist && isChecklist(targetChecklist)) {
      const nonDuplicateHydratedItems = hydratedItems.filter((item) => {
        return !_.find(
          targetChecklist.content,
          (targetItem) =>
            (isChecklistItem(targetItem) &&
              isChecklistItem(item) &&
              targetItem.item.content === item.item.content &&
              targetItem.setting.content === item.setting.content) ||
            (isChecklistHeader(targetItem) &&
              isChecklistHeader(item) &&
              targetItem.text === item.text)
        );
      });
      targetChecklist.content = targetChecklist.content.concat(nonDuplicateHydratedItems);
    } else {
      const role = templateChecklist.roles[0];
      const addedChecklist = newChecklist(checklistRoleDefaultTitles[role], role);
      addedChecklist.content = hydratedItems;

      const insertionPoint = _.sortedIndexBy(
        checklistDocument.contents.checklists,
        addedChecklist,
        (c) => {
          if (isChecklist(c) && c.role) {
            const idx = checklistRoles.indexOf(c.role[0]);
            return idx === -1 ? checklistRoles.length + 1 : idx;
          } else {
            return checklistRoles.length + 1;
          }
        }
      );

      checklistDocument.contents.checklists.splice(insertionPoint, 0, addedChecklist);
    }
  });
}
